import { NSARouterMakerResult } from "namirasoft-account-react";
import { LoadBalancerTargetInferencerType, LoadBalancerTargetInputRow } from "namirasoft-inference";
import { IBaseComponentProps, NSBoxInteger, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";
import InferencerTypeID from "./InferencerTypeID";
import TargetLineStyles from "./TargetLine.module.css";

export interface LoadBalancerTargetLineProps extends IBaseComponentProps, NSARouterMakerResult, InferenceRouterProps
{
	index: number;
	deletable: boolean;
	onDelete: () => void;
	onChanged?: (value: LoadBalancerTargetInputRow | null) => void;
}

const TARGET_INFO = { link: "https://namirasoft.com/inference/console-guide/load-balancer/#field-targets" };

const TYPE_LABEL: Record<LoadBalancerTargetInferencerType, string> = {
	[LoadBalancerTargetInferencerType.MODEL]: "Model",
	[LoadBalancerTargetInferencerType.LOAD_BALANCER]: "Load Balancer",
	[LoadBalancerTargetInferencerType.FAILOVER]: "Failover",
	[LoadBalancerTargetInferencerType.RACE]: "Race",
	[LoadBalancerTargetInferencerType.ROUTER]: "Router",
	[LoadBalancerTargetInferencerType.GATEWAY]: "Gateway",
};

export default class LoadBalancerTargetLine extends Component<LoadBalancerTargetLineProps>
{
	static IS_DIRTY(value: LoadBalancerTargetInputRow | null): boolean
	{
		if (value && value.inferencer_id)
			return true;
		return false;
	}

	private InferencerTypeID_Inferencer = createRef<InferencerTypeID<LoadBalancerTargetInferencerType>>();
	private NSBoxInteger_Weight = createRef<NSBoxInteger>();

	constructor(props: LoadBalancerTargetLineProps)
	{
		super(props);
		this.getValue = this.getValue.bind(this);
		this.isDirty = this.isDirty.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	getValue(checkError: boolean = false): LoadBalancerTargetInputRow | null
	{
		let inferencer = this.InferencerTypeID_Inferencer.current?.getValue(checkError) ?? { inferencer_type: LoadBalancerTargetInferencerType.MODEL, inferencer_id: "" };
		if (!inferencer.inferencer_id)
			return null;
		let weight = this.NSBoxInteger_Weight.current?.getValue(checkError) ?? 1;
		return { inferencer_type: inferencer.inferencer_type, inferencer_id: inferencer.inferencer_id, weight: weight ?? 1 };
	}

	setValue(value: LoadBalancerTargetInputRow)
	{
		this.InferencerTypeID_Inferencer.current?.setValue({ inferencer_type: value.inferencer_type, inferencer_id: value.inferencer_id });
		this.NSBoxInteger_Weight.current?.setValue(value.weight);
	}

	isDirty(): boolean
	{
		return LoadBalancerTargetLine.IS_DIRTY(this.getValue(false));
	}

	private onChanged()
	{
		if (this.props.onChanged)
			this.props.onChanged(this.getValue(false));
	}

	override render()
	{
		return (
			<NSRow style={{ ...this.props.style, flexWrap: "nowrap" }}>
				<InferencerTypeID<LoadBalancerTargetInferencerType>
					ref={this.InferencerTypeID_Inferencer}
					{...this.props}
					typeTitle="Type"
					idTitle={(type) => `${TYPE_LABEL[type]} ${this.props.index + 1}`}
					required={false}
					fill
					getEnumObject={() => LoadBalancerTargetInferencerType}
					defaultType={LoadBalancerTargetInferencerType.MODEL}
					onChanged={this.onChanged}
					info={TARGET_INFO}
					menu={{
						builtin: { delete: { enabled: this.props.deletable, onDelete: () => { this.props.onDelete(); } } },
						items: []
					}}
					typeClassList={[TargetLineStyles.side_cell]}
					idClassList={[TargetLineStyles.main_cell]}
				/>
				<NSBoxInteger
					ref={this.NSBoxInteger_Weight}
					title="Weight"
					required={false}
					min={1}
					classList={[TargetLineStyles.side_cell]}
					info={TARGET_INFO}
					onChanged={this.onChanged}
				/>
			</NSRow>
		);
	}
}